import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class PEBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { peTopic, peTitle, peContent0, peContent1, peListAd },
        } = this.props;

        return (
            <div id="peNewsList" className={styles.pe_box}>
                <Chip id="50063" type="struct" title="体育栏标题" groupName="体育栏" content={peTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75050"
                    type="recommend"
                    title="体育栏头条"
                    groupName="体育栏"
                    content={peTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75051"
                    type="recommend"
                    title="体育栏新闻列表1"
                    groupName="体育栏"
                    content={peContent0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList />
                </Chip>
                <Chip
                    id="75052"
                    type="recommend"
                    title="体育栏新闻列表1"
                    groupName="体育栏"
                    content={peContent1}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <NewsList hasTitle isList ad={peListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(PEBox);
